import React, { useEffect, useState } from 'react';
import './AmwayPromotion.scss';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPromotionProducts, resetPromotionProducts } from '../../../../thunk/lineOrdering.thunk';
import ItemCard from '../../itemCard/ItemCard';
import { MyDashboardStepsLoader } from '../../../challenge/challengeMyDashboard';
import { InfiniteScroll, Slideup } from '../../../../common';
import commonConstant, { CUSTOMER_SESSION_KEY, LINE_ORDERING_TABS_MAPPING, PROMOTION_GROUP_MAPPING } from '../../../../common/commonConstant';
import { useHistory } from 'react-router-dom';
import { getParamsString } from '../../../../utill.func';

const AmwayPromotion = ({ activeTab }) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const customer = useSelector(state => state.customer) || JSON.parse(sessionStorage.getItem(CUSTOMER_SESSION_KEY));
    const promotionData = useSelector(state => state.lineOrdering.PROMOTION);
    const promotionProducts = promotionData[PROMOTION_GROUP_MAPPING[activeTab].dataName];
    const [currentPage, setCurrentPage] = useState({
        [LINE_ORDERING_TABS_MAPPING.Amway.name]: 1,
        [LINE_ORDERING_TABS_MAPPING.NonAmway.name]: 1,
    });
    const [listLoading, setListLoading] = useState(false)
    const isPublic = customer?.type?.toLowerCase() === 'public';

    useEffect(() => {
        if (activeTab) {
            if (promotionProducts) {
                setCurrentPage({ ...currentPage, [activeTab]: promotionProducts.currentPage + 1 });
            }
            if (!promotionProducts) {
                fetchData();
            }
        }
    }, [activeTab])

    const fetchData = () => {
        if (!promotionProducts || (promotionProducts?.total > promotionProducts?.products?.length && !listLoading)) {
            setListLoading(true)
            const params = {
                currentPage: currentPage[activeTab],
                promotionGroup: PROMOTION_GROUP_MAPPING[activeTab].name,
                userId: customer.uid,
                perPage: 10,
                type: activeTab
            }
            dispatch(fetchPromotionProducts(params)).finally(() => setListLoading(false));
            setCurrentPage({ ...currentPage, [activeTab]: currentPage[activeTab] + 1 });
        }
    }

    const handleClick = product => {

        const params = {
            id: product.id,
            active: activeTab
        };
        history.push(`${commonConstant.pathProductPromotion}?${getParamsString(params)}`);
    }

    return (
        <div className='amway-promotion-container'>
            {
                promotionData?.loading && !promotionProducts ?
                    <> {Array(2).fill().map((el, index) => <MyDashboardStepsLoader key={index} />)} </> :
                    <>
                        <div className='product-total'>ทั้งหมด {promotionProducts?.total} รายการ</div>
                        {
                            promotionProducts?.products?.length &&
                            <InfiniteScroll
                                items={promotionProducts?.products}
                                loading={listLoading}
                                itemComponent={ItemCard}
                                itemProps={{ handleClick, isPublic }}
                                fetchData={fetchData}
                                loaderComponent={MyDashboardStepsLoader}
                            />
                        }
                    </>
            }
            <Slideup />
        </div>
    )
}

export default AmwayPromotion
